import React from 'react';
import { FiUsers } from 'react-icons/fi';
import { WidgetDef } from '../types';
import { DemoHead } from '../shared';

// spec 621:5857 — no settings
const HOLDERS = [
    { holder: 'Alpha Custody Nominees Pty Limited', shares: '23,624,880', pct: '18.40%' },
    { holder: 'Beta Global Nominees Pty Ltd', shares: '11,684,400', pct: '9.10%' },
    { holder: 'Mr Kenneth James Parker', shares: '11,684,400', pct: '9.10%' },
    { holder: 'Acme Constructions Pty Ltd', shares: '8,602,800', pct: '6.70%' },
    { holder: 'Northstar Mining Inc', shares: '7,575,600', pct: '5.90%' },
];

const topShareholders: WidgetDef = {
    slug: 'top-20-shareholders',
    name: 'Top 20 shareholders',
    description: 'The largest holders and the percentage they hold',
    icon: <FiUsers />,
    title: 'Top 20 Shareholders Widget',
    installed: true,
    page: '/investors/shareholder-information/',
    views: 410,
    getCodeButton: true,
    demoPath: '/investors/shareholder-information/',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_top_holders count=20 instance="top-20"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="top-20" data-investi="top-holders" data-count="20"></div>', dark: true },
    ],
    Demo: () => <div className="wd-top20">
        <DemoHead title="Top 20 shareholders" sub="Register as at 2 September 2026" />
        <div className="wd-data-table">
            <div className="tr th"><span>Holder</span><span>Shares</span><span>%</span></div>
            {HOLDERS.map(h => <div key={h.holder} className="tr"><span>{h.holder}</span><span>{h.shares}</span><span>{h.pct}</span></div>)}
        </div>
        <p className="muted small">Top 20 hold 67.9% of the company · 772 holders in total</p>
    </div>,
};

export default topShareholders;
